import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useParams, useNavigate } from 'react-router';
import { useToast } from '../Hooks/useToast';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  CircularProgress,
  InputAdornment,
  IconButton
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
 
export const FetchAdminResetPassword = async (data, token) => {
  const API_URL = process.env.REACT_APP_API_URL +"/auth/admin/reset-password/"+token
  
  console.log("Making request to:", API_URL); 
  console.log("Request payload:", {
    password: data.password,
    passwordConfirm: data.passwordConfirm
  });

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        password: data.password,
        passwordConfirm: data.passwordConfirm,
      })
    });

    if (!response.ok) {
      const errorResponse = await response.json();
      console.error("Server error:", errorResponse);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Fehler beim Zurücksetzen des Passworts:", error);
    return false;
  }
};


const ResetPassword = () => {
  const { toastSuccess, toastError } = useToast();
  const { token } = useParams();
  console.log(token )
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const resetPasswordFormik = useFormik({
    initialValues: {
      password: '',
      passwordConfirm: '',
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, 'Mindestens 8 Zeichen erforderlich')
        .required('Passwort ist erforderlich'),
      passwordConfirm: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwörter müssen übereinstimmen')
        .required('Passwortbestätigung ist erforderlich'),
    }),
    onSubmit: async (values) => {
      try {
        const success = await FetchAdminResetPassword({
          password: values.password,
          passwordConfirm: values.passwordConfirm
        }, token);
        
        
        if (success) {
          toastSuccess("Passwort erfolgreich zurückgesetzt!");
          navigate('/adminlogin');
        } else {
          toastError("Fehler beim Zurücksetzen des Passworts");
        }
      } catch (error) {
        toastError("Fehler beim Zurücksetzen des Passworts");
      }
    }
  });

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ 
        mt: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography color='#D6B981' component="h1" variant="h5" align="center" sx={{ mb: 3 }}>
            Passwort zurücksetzen
          </Typography>
          
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
            Bitte geben Sie Ihr neues Passwort ein
          </Typography>
          
          <Box component="form" onSubmit={resetPasswordFormik.handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="password"
              name="password"
              label="Neues Passwort"
              type={showPassword ? 'text' : 'password'}
              autoComplete="new-password"
              value={resetPasswordFormik.values.password}
              onChange={resetPasswordFormik.handleChange}
              onBlur={resetPasswordFormik.handleBlur}
              error={resetPasswordFormik.touched.password && !!resetPasswordFormik.errors.password}
              helperText={resetPasswordFormik.touched.password && resetPasswordFormik.errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            
            <TextField
              margin="normal"
              required
              fullWidth
              id="passwordConfirm"
              name="passwordConfirm"
              label="Passwort bestätigen"
              type={showConfirmPassword ? 'text' : 'password'}
              autoComplete="new-password"
              value={resetPasswordFormik.values.passwordConfirm}
              onChange={resetPasswordFormik.handleChange}
              onBlur={resetPasswordFormik.handleBlur}
              error={resetPasswordFormik.touched.passwordConfirm && !!resetPasswordFormik.errors.passwordConfirm}
              helperText={resetPasswordFormik.touched.passwordConfirm && resetPasswordFormik.errors.passwordConfirm}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      edge="end"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={resetPasswordFormik.isSubmitting}
              sx={{bgcolor:"#D6B981", mt: 3, mb: 2, py: 1.5 }}
            >
              {resetPasswordFormik.isSubmitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Passwort zurücksetzen'
              )}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ResetPassword;